// eslint-disable-next-line import/no-cycle
import {ErrorRouteNames} from '@client/routes/errors';
// eslint-disable-next-line import/no-cycle
import {LoginRouteNames} from '@client/routes/login';
import {OverviewRouteNames} from '@client/routes/overview';
import {getUser} from '@simpleinvest/front-end-auth';
import {Route, NavigationGuardNext} from 'vue-router';
import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';

export enum IndexRouteNames {
  Home = 'Home',
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

const routes = [
  {
    path: '/clientdashboard',
    name: IndexRouteNames.Home,
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      try {
        await getUser();
        if (await onboardingLiveBeforeServicing()) {
          window.location.href =
            process.env.VUE_APP_ENV === 'prod'
              ? 'https://advisedservices.individuals.principal.com'
              : 'https://advisedservices.individuals.staging.principal.com';
        } else {
          // eslint-disable-next-line callback-return
          next({name: OverviewRouteNames.OverviewPage});
        }
      } catch {
        // eslint-disable-next-line callback-return
        next({name: LoginRouteNames.LoginPage});
      }
    },
  },
  // TODO: find home for this route in route file
  {
    path: '/clientdashboard/designations',
    name: 'AccountSettings',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/components/userprofile/AccountSettings.vue'),
  },
  {
    path: '*',
    redirect: {
      name: ErrorRouteNames.NotFoundPage,
    },
  },
];

export default routes;
